import React from 'react'
import CloseModal from './closemodal';

const ModalBody = ({children, heading = '', headingCenter=false}) => {
    return (
        <div className="modal-body relative">
            <CloseModal btnType="btn-close btn-link" name={<i className="fas fa-times"></i>} />
            <div className="modalheader m-b-15">
                <h3 className={`m-t-10 ${headingCenter ? 'text-center' : ''}`.trim()}>{heading}</h3>
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}

export default ModalBody
